import { render } from "./MemberItem.vue?vue&type=template&id=ef2f33e0&scoped=true"
import script from "./MemberItem.vue?vue&type=script&lang=js"
export * from "./MemberItem.vue?vue&type=script&lang=js"

import "./MemberItem.vue?vue&type=style&index=0&id=ef2f33e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef2f33e0"]])

export default __exports__